import "./Thankyou.css"
import thankyouImage from "../../assets/thank-you.png"
import { FiArrowUpRight } from "react-icons/fi";
import { Link } from "react-router-dom";

const Thankyou = () => {
    return (
        <div className="thankyou">
            <div className="thankyou-header ">
                <img
                    src={thankyouImage}
                    alt="Thank You"
                    className="thankyou-image"
                />
            </div>
            <div className="thankyou-content container">
                <h1>Thank You!</h1>
                <p>Thank you for submitting the form. Our team will review it and respond as quickly as possible.</p>
                <Link to="/blog">
                    <button className="btn-icon-primary" >
                        See Our Blogs
                        <FiArrowUpRight />
                    </button>
                </Link>
            </div>
        </div>
    )
}

export default Thankyou